import {
  PageBlueprint,
  createRouteRef,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { compatWrapper } from '@backstage/core-compat-api';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';

const entityValidationRouteRef = createRouteRef();

// entity-validation 0.20 ships a new-frontend-system `/alpha` plugin (auto-
// discovered via app.packages: all), but its page extension carries no icon, so
// it never appears in the sidebar. We override `page:entity-validation` with our
// own PageBlueprint: title + icon + routeRef together make the new frontend
// system infer a nav item (same pattern as the kubernetes module). The page
// component itself is legacy-frontend, so we wrap it with compatWrapper.
const entityValidationPage = PageBlueprint.make({
  params: {
    path: '/entity-validation',
    title: 'Entity Validation',
    icon: <CheckCircleOutlineIcon />,
    routeRef: entityValidationRouteRef,
    loader: async () => {
      const { EntityValidationPage } = await import(
        '@backstage-community/plugin-entity-validation'
      );
      return compatWrapper(<EntityValidationPage />);
    },
  },
});

export const entityValidationModule = createFrontendModule({
  pluginId: 'entity-validation',
  extensions: [entityValidationPage],
});